import React from "react";
import { Link } from "react-router-dom";
import { services } from "../../data/services";
import SectionHeading from "../UI/SectionHeading";
import Icon from "../UI/Icon";

export default function Services() {
  return (
    <section className="bg-paper">
      <div className="max-w-site mx-auto px-5 sm:px-10 py-16 md:py-24">
        <SectionHeading
          eyebrow="What we do"
          title="Thoughtful carpentry from start to finish"
          intro="Built-ins, bespoke joinery and outdoor projects designed around the way you live. Explore each service to see how we can help."
          center
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
          {services.map((s) => (
            <Link
              key={s.slug}
              to={`/carpentry-services/${s.slug}`}
              className="group bg-linen border border-hairline overflow-hidden hover:border-oak transition-colors flex flex-col"
            >
              <div className="h-52 overflow-hidden relative">
                <img
                  src={s.image}
                  alt={s.cardTitle}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-4 left-4 w-11 h-11 flex items-center justify-center bg-paper/95 text-oak shadow-sm">
                  <Icon name={s.icon} className="w-6 h-6" />
                </span>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-display font-semibold text-xl text-ink group-hover:text-oak transition-colors">
                  {s.cardTitle}
                </h3>
                <p className="text-bark leading-7 mt-2 flex-1">{s.cardBlurb}</p>
                <span className="inline-flex items-center gap-2 text-oak font-bold text-sm uppercase tracking-wide mt-4">
                  Learn more
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="group-hover:translate-x-1 transition-transform">
                    <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
